export const enumSearchOuLabel = {
    VILLE : "villesLabel",
    DEPARTEMENT : "departementsLabel",
    REGION : "regionsLabel",
    PAYS : "paysLabel",
    ETABLISSEMENT : "etablissementLabel"
}